/* eslint-disable no-nested-ternary */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { INVESTOR_APP_DOMAIN } from '../../config';
import {
  formatCurrency,
  formatShares,
  investmentInstruments,
  sectors,
  offerStatuses,
  offerTypes,
  listingTypes,
  fundTypes,
  fundStructureOptions,
} from 'entoro-shared';
import { validateOfferPasswordMutation } from '../../apollo';
import { connect } from 'react-redux';
import OfferFavorite from '../OfferFavorite';
import OfferPwdAction from '../Dashboard/OfferPwd/OfferPwdAction';
import { CRYPTO_COMPARE_KEY } from '../../config';

const formatAllCurrency = (value, currency = 'USD') => {
  // Validate currency code
  const currencyCodes = new Set(Intl.supportedValuesOf('currency'));
  const validCurrencyCode = currencyCodes.has(currency) ? currency : 'USD';

  // Format the value with respect to the specified currency
  const currencySymbols = Array.from(currencyCodes)
    .map((currencyCode) => {
      try {
        return Intl.NumberFormat('en', {
          style: 'currency',
          currency: currencyCode,
        })
          .formatToParts(0)
          .find((part) => part.type === 'currency');
      } catch (error) {
        return undefined;
      }
    })
    .filter((currencySymbol) => currencySymbol !== undefined);

  const currencySymbol = currencySymbols.find(
    (symbol) => symbol !== undefined && symbol.unit === validCurrencyCode
  );

  const formattedValue = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: validCurrencyCode,
    currencyDisplay: 'symbol',
    currencySign: 'accounting',
    ...(currencySymbol && { currencyDisplay: 'code' }),
  }).format(value);

  return formattedValue;
};

class OfferCard extends React.Component {
  state = {
    isOfferPasswordCorrect: false,
    mainDialogOpen: false,
    confirmDialogOpen: true,
  };

  handleClickOpen = () => {
    this.setState({ mainDialogOpen: true });
  };

  handleClose = () => {
    this.setState({ mainDialogOpen: false });
  };
  changeOfferPassStatus = () => {
    this.setState({ isOfferPasswordCorrect: true });
  };
  componentWillUnmount() {
    this.setState({ isOfferPasswordCorrect: false });
  }

  renderRedirect = (
    isDisabled,
    isAuthenticated,
    isPremarketing,
    offer,
    tenant,
    mainDialogOpen,
    rememberOfferPwd
  ) => {
    if (
      typeof offer.sharedTenants != undefined &&
      offer.sharedTenants != null &&
      offer.tenantId != tenant._id
    ) {
      const authToken = localStorage.getItem('authToken');
      //this is a shared tenannt
      return offer.offerPassword &&
        !rememberOfferPwd &&
        !this.state.isOfferPasswordCorrect ? (
        <OfferPwdAction
          handleChangeOfferPassStatus={this.changeOfferPassStatus}
          open={mainDialogOpen}
          handleClickOpen={this.handleClickOpen}
          handleClose={this.handleClose}
          mutation={validateOfferPasswordMutation}
          title={'Private Offering'}
          offerId={offer._id}
          isAuthenticated={isAuthenticated}
        />
      ) : (
        //input the hidden form here.
        //the challenge is , when the user is loggin here, the session is still not transferable
        <Link
          target='_blank'
          style={
            isDisabled ? { cursor: 'initial', pointerEvents: 'none' } : null
          }
          // eslnt-disable-next-line no-underscore-dangle
          to={{
            pathname: `${
              isDisabled
                ? '/dashboard'
                : offer.tenant.customDomain
                ? `http://${offer.tenant.domainPrefix}/offer/${
                    offer.isVanityUrl ? offer.vanityUrl : offer._id
                  }?auth_r=${authToken}&refTenant=${tenant._id}`
                : `http://${
                    offer.tenant.domainPrefix
                  }.${INVESTOR_APP_DOMAIN}/offer/${
                    offer.isVanityUrl ? offer.vanityUrl : offer._id
                  }?auth_r=${authToken}&refTenant=${tenant._id}`
            }`,
          }}
          className={`button w-button ${isDisabled ? 'disabled-btn' : ''}`}
        >
          {isPremarketing ? 'Coming Soon' : 'Learn More'}
        </Link>
      );
    } else {
      return offer.offerPassword &&
        !rememberOfferPwd &&
        !this.state.isOfferPasswordCorrect ? (
        <OfferPwdAction
          handleChangeOfferPassStatus={this.changeOfferPassStatus}
          open={mainDialogOpen}
          handleClickOpen={this.handleClickOpen}
          handleClose={this.handleClose}
          mutation={validateOfferPasswordMutation}
          title={'Private Offering'}
          offerId={offer._id}
          isAuthenticated={isAuthenticated}
        />
      ) : (
        <Link
          style={
            isDisabled ? { cursor: 'initial', pointerEvents: 'none' } : null
          }
          // eslint-disable-next-line no-underscore-dangle
          to={{
            pathname: `${
              isDisabled
                ? '/dashboard'
                : `/offer/${offer.isVanityUrl ? offer.vanityUrl : offer._id}`
            }`,
          }}
          className={`button w-button ${isDisabled ? 'disabled-btn' : ''}`}
        >
          {isPremarketing ? 'Coming Soon' : 'Learn More'}
        </Link>
      );
    }
  };

  render() {
    const { tenant } = this.context;
    const { mainDialogOpen } = this.state;
    const { offer, isAuthenticated } = this.props;
    const authToken = isAuthenticated
      ? localStorage.getItem('authToken')
      : ' false';

    const rememberOfferPwd =
      localStorage.getItem(
        `${localStorage.getItem('authToken')}${CRYPTO_COMPARE_KEY.concat(
          offer._id
        )}`
      ) === `${authToken.concat(offer._id)}${CRYPTO_COMPARE_KEY}`; // check if rememberOfferpassword is set
    const isPremarketing = offer.status === 'PREMARKETING';
    const isFunded = offer.status === 'FUNDED';
    const isDisabled = isPremarketing || isFunded;
    const isSelfDirected = offer.status === 'SELFDIRECTED';
    const { listingType, closingDate } = offer;

    // 506b alternative name
    const BannerName = isAuthenticated
      ? `${offer.issuerCompany.name}`
      : `${offer.altOfferTitle}`;

    const isCompanyName =
      offer.typeOfOffer === 'Reg_D_506b'
        ? BannerName
        : offer.issuerCompany.name;

    const CompanyName = isCompanyName || offer.issuerCompany.name;

    const closingDateChecker =
      closingDate && +new Date(`${closingDate}`) - +new Date() < 0;

    const classes = [
      'status-label',
      isFunded && 'funded',
      isSelfDirected && 'selfdirected',
    ]
      .filter(Boolean)
      .join(' ');
    return (
      <div className='card'>
        <div
          className='card-header w-clearfix'
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, .6), hsla(0, 0%, 100%, 0)), url(${offer.tombstoneImageUrl})`,
          }}
        >
          <div className='white-44'>{isPremarketing ? null : CompanyName}</div>
          {!isPremarketing && (
            <div className={classes}>
              <div>{offerStatuses.getLabel(offer.status)}</div>
            </div>
          )}
        </div>

        {/* {((listingType !== 'ASSET_SALES' && offer.typeOfOffer !== 'REG_CF') ||
          offer.typeOfOffer !== 'REG_A') && ( */}
        <div
          style={{
            color: '#fff',
            fontSize: '20px',
            fontWeight: '500',
            display: 'flex',
            backgroundColor:
              listingType === 'CARBON_CREDIT'
                ? '#37782C'
                : listingType === 'DIRECT_PLACEMENT'
                ? '#024064'
                : listingType === 'FUNDS'
                ? '#A63828'
                : listingType === 'SECURITIZED_TOKEN_OFFERING'
                ? '#E5B509'
                : listingType === 'ASSET_SALES'
                ? '#9FD983'
                : listingType === 'HARD_ASSETS'
                ? '#a2b701'
                : listingType === 'ALTERNATIVE_ASSETS'
                ? '#64BB6A'
                : listingType === 'ACQUISITIONS_AND_DIVESTITURES'
                ? '#dba40f'
                : listingType === 'SECONDARY_SALES'
                ? '#D90E44'
                : listingType === 'REAL_ESTATE'
                ? '#826063'
                : listingType === 'M_AND_A'
                ? '#5d6013'
                : listingType === 'SERIES_A'
                ? '#3a1b37'
                : listingType === 'SERIES_B'
                ? '#e84e81'
                : listingType === 'SERIES_C'
                ? '#c9081e'
                : listingType === 'PRE_SEED'
                ? '#3a5e5d'
                : listingType === 'SEED'
                ? '#633b29'
                : listingType === 'GROWTH'
                ? '#DE315C'
                : listingType === 'CORPORATE_BROKING'
                ? '#a1c6bc'
                : listingType === 'DEBT_ADVISORY_RESTRUCTURING'
                ? '#7bc3f7'
                : listingType === 'EQUITY_CAPITAL_MARKETS'
                ? '#9da5a5'
                : listingType === 'FINANCIAL_SPONSORS'
                ? '#9a47a5'
                : listingType === 'FIXED_INCOME'
                ? '#c13f98'
                : listingType === 'IMPACT'
                ? '#c9d820'
                : listingType === 'Reg_A'
                ? '#41444f'
                : listingType === 'Reg_D'
                ? '#8023B8'
                : listingType === 'Reg_D_506b'
                ? '#DCACFA'
                : listingType === 'WATER'
                ? '#3CB3C0'
                : listingType === 'ART_FINANCE'
                ? '#9E1B33'
                : tenant.theme.secondaryColor,
          }}
        >
          <div className='ht30 fs-15  '>
            {listingTypes.getLabel(listingType)}
          </div>
          <div className='placard-child ht30 fs-15'>
            {offerTypes.getLabel(offer.typeOfOffer)}
          </div>
        </div>
        {/* )} */}

        <div className='card-bottom'>
          <div className='sector-label sector'>
            {listingType === 'ACQUISITIONS_AND_DIVESTITURES' ? (
              <Fragment>
                <div className='text-subsector-label'>
                  {offer.primaryObjective}
                </div>
                <div className='text-sector-label'>Primary Objective</div>
              </Fragment>
            ) : listingType === 'FUNDS' ? (
              <Fragment>
                <div className='text-subsector-label'>
                  {fundTypes.getLabel(offer.fundType)}
                </div>
                <div className='text-sector-label'>Fund Type</div>
              </Fragment>
            ) : offer.typeOfOffer === 'Carbon_Credit' ? (
              <Fragment>
                <div className='text-subsector-label'>
                  {offer.productDeveloper}
                </div>
                <div className='text-sector-label'>Product Developer</div>
              </Fragment>
            ) : (
              <Fragment>
                <div className='text-subsector-label'>
                  {sectors.getGroupTitle(offer.sector)}
                </div>
                <div className='text-sector-label'>
                  {sectors.getLabel(offer.sector)}
                </div>
              </Fragment>
            )}
            {closingDateChecker && (
              <div
                style={{
                  padding: '10px',
                  backgroundColor: 'red',
                  height: '30px',
                  width: '120px',
                  color: '#fff',
                  borderRadius: '10%',
                }}
              >
                Offer Closed
              </div>
            )}
          </div>
          <div
            className='sector-label w-clearfix'
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <div className='target-raise-cell'>
                {listingType === 'SECONDARY_SALES' && (
                  <Fragment>
                    <div className='text-target-raise'>
                      {formatShares(offer.sharesForSale)}
                    </div>
                    <div className='card-navy-detail'>Shares for Sale</div>
                  </Fragment>
                )}
                {listingType === 'ACQUISITIONS_AND_DIVESTITURES' && (
                  <Fragment>
                    <div className='text-target-raise'>
                      {offer.averageDailyProduction}
                    </div>
                    <div className='card-navy-detail'>
                      Average Daily Production
                    </div>
                  </Fragment>
                )}
                {listingType === 'ASSET_SALES' && (
                  <Fragment>
                    <div className='text-target-raise'>{offer.valueRange}</div>
                    <div className='card-navy-detail'>Value Range</div>
                  </Fragment>
                )}
                {listingType !== 'SECONDARY_SALES' &&
                  listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
                  listingType !== 'ASSET_SALES' &&
                  offer.typeOfOffer !== 'Carbon_Credit' && (
                    <Fragment>
                      <div className='text-target-raise'>
                        {formatCurrency(offer.targetRaise)}
                        {/* {formatAllCurrency(
                          offer.targetRaise,
                          offer.offerCurrency
                        )} */}
                      </div>
                      <div className='card-navy-detail'>Target Raise</div>
                    </Fragment>
                  )}
              </div>
              <div className='min-invest-cell'>
                {listingType === 'ACQUISITIONS_AND_DIVESTITURES' && (
                  <Fragment>
                    <div className='text-min-investment'>
                      {formatShares(offer.netAcres)}
                    </div>
                    <div className='card-grey-detail'>Net Acres</div>
                  </Fragment>
                )}
                {listingType === 'ASSET_SALES' && (
                  <Fragment>
                    <div className='text-min-investment'>
                      {offer.assetStatus}
                    </div>
                    <div className='card-grey-detail'>Asset Status</div>
                  </Fragment>
                )}
                {listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
                  listingType !== 'ASSET_SALES' &&
                  offer.typeOfOffer !== 'Carbon_Credit' && (
                    <Fragment>
                      <div style={{ float: 'right' }}>
                        <div className='text-min-investment'>
                          {formatCurrency(offer.minimumInvestment) || 'N/A'}
                        </div>
                        <div className='card-grey-detail'>
                          Minimum Investment
                        </div>
                      </div>
                    </Fragment>
                  )}
              </div>
            </div>
            <div
              className='min-invest-cell'
              style={{
                width: '100%',
              }}
            >
              {offer.typeOfOffer === 'Carbon_Credit' && (
                <Fragment>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '0px 8px',
                    }}
                  >
                    <div style={{ width: '50%' }}>
                      <div className='text-sector-label text-target-raise'>
                        {offer.product}
                      </div>
                      <div className='text-carbon_credit card-navy-detail'>
                        Product
                      </div>
                    </div>
                    <div style={{ width: '50%' }}>
                      <div className='text-sector-label text-min-investment'>
                        {offer.creditIssued}
                      </div>
                      <div className='card-grey-detail'>Credits Issued</div>
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
          <div className='sector-label'>
            {listingType === 'ACQUISITIONS_AND_DIVESTITURES' ? (
              <Fragment>
                <div className='text-instrument'>{offer.county}</div>
                <div className='card-grey-detail'>County</div>
              </Fragment>
            ) : listingType === 'FUNDS' ? (
              <Fragment>
                <div className='text-instrument'>
                  {fundStructureOptions.getLabel(offer.fundStructure)}
                </div>
                <div className='card-grey-detail'>Fund Structure</div>
              </Fragment>
            ) : offer.typeOfOffer === 'Carbon_Credit' ? (
              <Fragment>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '0px 8px',
                  }}
                >
                  <div style={{ width: '50%' }}>
                    <div className='text-instrument'>{offer.vintage}</div>
                    <div className='card-grey-detail'>Vintages</div>
                  </div>
                  <div style={{ width: '50%' }}>
                    <div className='text-instrument'>{offer.region}</div>
                    <div className='card-grey-detail'>Region</div>
                  </div>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <div className='text-instrument'>
                  {investmentInstruments.getLabel(offer.investmentInstrument)}
                </div>
                <div className='card-grey-detail'>Investment Instrument</div>
              </Fragment>
            )}
          </div>
        </div>

        <div className='card-cta-container'>
          {this.renderRedirect(
            isDisabled,
            isAuthenticated,
            isPremarketing,
            offer,
            tenant,
            mainDialogOpen,
            rememberOfferPwd
          )}

          {isAuthenticated && <OfferFavorite tenant={tenant} offer={offer} />}
        </div>
      </div>
    );
  }
}
OfferCard.propTypes = {
  offer: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};
OfferCard.contextTypes = {
  tenant: PropTypes.object,
};
const mapStateToProps = ({ session, investorUser }) => ({
  investorUser,
  isAuthenticated: session.isAuthenticated,
});

export default connect(mapStateToProps)(OfferCard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferCard.js